// The brand faces, self-hosted through Fontsource. Bundled rather than fetched from a
// CDN so the native app renders correctly with no network at all.
import "@fontsource/syncopate/400.css";
import "@fontsource/syncopate/700.css";
import "@fontsource/gilda-display/400.css";
// The variable cut carries every weight the type scale uses in a single file.
import "@fontsource-variable/outfit";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "~/App";
import { normalizeDirectInviteLocation } from "~/lib/invite-links";
import { normalizeDirectLiveLocation } from "~/lib/live-links";

normalizeDirectInviteLocation();
normalizeDirectLiveLocation();

const container = document.getElementById("root");
if (!container) throw new Error("Root container is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
